import axios from 'axios';
import { BASE_URL } from './../api/config';
const instance = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' }
});
instance.interceptors.request.use(config => {
    const token = localStorage.getItem('authToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => Promise.reject(error));
export default instance;
//# sourceMappingURL=axiosInstance.js.map